export default { sha: '4c02665f86ee76503c169cf2a80037cc91c93db1', buildNumber: 'undefined' }
